import React, { createContext, useContext, useState, useEffect, useLayoutEffect as useClientLayoutEffect } from "react";
import { translations } from "../i18n/translations";

const LanguageContext = createContext();

const SUPPORTED = ["en", "fr", "es"];
const useLayoutEffect = typeof window === "undefined" ? useEffect : useClientLayoutEffect;

export const LanguageProvider = ({ children }) => {
  // Start in English so the client matches the prerendered HTML, then switch before paint.
  const [lang, setLang] = useState("en");
  const [ready, setReady] = useState(false);

  useLayoutEffect(() => {
    const stored = window.localStorage.getItem("eb_lang");
    const browser = (navigator.language || "en").slice(0, 2).toLowerCase();
    const detected = SUPPORTED.includes(stored) ? stored : SUPPORTED.includes(browser) ? browser : "en";
    setLang(detected);
    setReady(true);
  }, []);

  useEffect(() => {
    if (!ready) return;
    try {
      window.localStorage.setItem("eb_lang", lang);
      document.documentElement.lang = lang;
    } catch (e) {
      /* no-op */
    }
  }, [lang, ready]);

  const t = (path) => {
    const keys = path.split(".");
    let node = translations[lang];
    for (const k of keys) {
      if (node && k in node) node = node[k];
      else {
        // fallback to english
        node = translations.en;
        for (const k2 of keys) {
          if (node && k2 in node) node = node[k2];
          else return path;
        }
        return node;
      }
    }
    return node;
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, supported: SUPPORTED }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used within a LanguageProvider");
  return ctx;
};
